module.exports = __webpack_public_path__ + "img/team-16.df493143.jpg";